// extracted by mini-css-extract-plugin
module.exports = {"tutorial_step":"Tutorial_tutorial_step__27ZIB","step_num":"Tutorial_step_num__1EzIE","img_container":"Tutorial_img_container__1ex1F","align_bottom":"Tutorial_align_bottom__1cQGr"};